const docgroups = require('./docgroups');

const pagesReducer = (acc, curr) => ({ ...acc, [curr.doctype]: curr.name });
const groupsReducer = (acc, curr) => ({
  ...acc,
  ...curr.items.reduce(pagesReducer, {}),
  [curr.docgroup]: curr.name,
});

module.exports = docgroups.reduce(groupsReducer, {});
